<template>
  <Dialog
    :visible="visible"
    :header="title"
    :modal="true"
    :closable="!loading"
    :draggable="false"
    :style="{ width }"
    @update:visible="handleVisibilityChange"
  >
    <div class="py-2">
      <slot></slot>
    </div>

    <template #footer>
      <slot name="footer">
        <div class="flex justify-content-end gap-2">
          <Button
            :label="cancelLabel"
            severity="secondary"
            text
            @click="closeModal"
            :disabled="loading"
          />
          <!-- data-testid: pruebas automáticas (e2e/) -->
          <Button
            :label="confirmLabel"
            :loading="loading"
            data-testid="modal-confirmar"
            @click="$emit('confirm')"
          />
        </div>
      </slot>
    </template>
  </Dialog>
</template>

<script>
import Dialog from "primevue/dialog";
import Button from "primevue/button";

export default {
  name: "ZapiModalShell",
  components: {
    Dialog,
    Button,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "Modal",
    },
    width: {
      type: String,
      default: "38rem",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    cancelLabel: {
      type: String,
      default: "Cancelar",
    },
    confirmLabel: {
      type: String,
      default: "Guardar",
    },
  },
  emits: ["update:visible", "confirm"],
  methods: {
    handleVisibilityChange(value) {
      this.$emit("update:visible", value);
    },
    closeModal() {
      this.$emit("update:visible", false);
    },
  },
};
</script>
